import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import './NotifScreen.scss'
import { Fire, Tools, Popup, Time } from '../../../services'

import { Label } from 'reactstrap'
import Switch from 'react-switch'
import Select from 'react-select'
import { Headerbar, NotifPreview, MyDateTimePicker, FormInput, HTMLEditor, YesNo, Loader, EditContainer, ImagesPicker } from '../../Reusable'

import FadeIn from 'react-fade-in';

const { useHistory } = require('react-router-dom')

interface Props {
  match: any;
}
const NotifScreen: React.FC<Props> = (props) => {

  const [error, setError] = React.useState('')
  const [errors, setErrors] = React.useState<any>({})
  const [events, setEvents] = React.useState<any[]>([])
  const [discounts, setDiscounts] = React.useState<any[]>([])
  const [places, setPlaces] = React.useState<any[]>([])
  const [selectedAd, selectAd] = React.useState<any>(null)
  const history = useHistory()
  const user = useSelector(state => state.authReducer.user)

  React.useEffect(() => {
    retrieveData()
  }, [])

  React.useEffect(() => {
    console.log(selectedAd)
  }, [selectedAd])

  const retrieveData = async () => {
    try {
      const eventsRef = Fire.store().collection('ads')
        .where('type', '==', 'event')
        .where('published', '==', true)
        .where('dateEnd', '>=', new Date())
        .orderBy('dateEnd')
      const listEvents = await Fire.list(eventsRef)
      const events: any[] = []
      for (const event of listEvents) {
        events.push({ value: event.id, label: event.name })
      }
      setEvents(events)
      const discountsRef = Fire.store().collection('ads')
        .where('type', '==', 'discount')
        .where('published', '==', true)
        .orderBy('createdAt')
      const listDiscounts = await Fire.list(discountsRef)
      const discounts: any[] = []
      for (const discount of listDiscounts) {
        discounts.push({ value: discount.id, label: discount.name })
      }
      setDiscounts(discounts)
      const placesRef = Fire.store().collection('ads')
        .where('type', '==', 'place')
        .where('published', '==', true)
        .orderBy('createdAt')
      const listPlaces = await Fire.list(placesRef)
      const places: any[] = []
      for (const place of listPlaces) {
        places.push({ value: place.id, label: place.name })
      }
      setPlaces(places)
    } catch (err) {
      console.log(err.message)
    }
  }

  const onSave = async (item: any, pictures: any[]) => {}
  const onRemove = async (item: any) => {}

  const sendPush = async (item: any) => {
    const confirm = window.confirm('Êtes-vous sûr de vouloir envoyer cette notification ?')
    if (!confirm)
      return;

    try {
      const payload: any = {
        ...item,
        senderId: user.id,
        type: 'all',
        was_sent: false,
        cancelled: false,
        createdAt: new Date(),
      }

      if (selectedAd) {
        payload.adId = selectedAd.value
        console.log(payload)
      }

      await Fire.store().collection('notifs').add(payload)
      history.push('/admin/notifs')
    } catch (err) {
      console.warn(err)
    }
  }

  const canSend = (item: any) => {
    return (item.title && item.title.length &&
      item.message && item.message.length)
  }

  const wasRequired = (value: any) => {
    return value && value.length > 0
  }

  const updateErrors = (item: any) => {
    const errors: any = {}
    // Title check
    if (!wasRequired(item.title))
      errors.title = 'Champs obligatoire'
    // Message check
    if (!wasRequired(item.message))
      errors.message = 'Champs obligatoire'

    setErrors(errors)
  }

  const renderContent = ({item, onChange, save, saving, changed, setChanged}) => {
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Envoyer une notification</h3>
        </div>

        <div className="card-body">
          
          <NotifPreview
            title={item.title}
            message={item.message}
            />

          <FormInput
            placeholder="Titre de la notif"
            value={item.title}
            error={errors.title}
            onChange={(evt) => onChange('title', evt.target.value)}
            />
          <FormInput
            textarea
            rows={3}
            error={errors.message}
            placeholder="Message de la notif"
            value={item.message}
            onChange={(evt) => onChange('message', evt.target.value)}
            />

          <div className="input-wrapper">
            <Label>Rediriger vers une annonce:</Label>
            <Select
              value={selectedAd}
              onChange={selectAd}
              options={[
                {
                  label: "Evènements",
                  options: events
                },
                {
                  label: "Bons plans",
                  options: discounts
                },
                {
                  label: "Points de vente",
                  options: places
                },
              ]}
              wrapperStyle={{marginBottom: 12}}
              />

          </div>

          <YesNo
            value={!!item.date}
            label="Planifier l'envoie"
            onChange={(checked) => {
              if (checked) {
                onChange('date', new Date())
              } else {
                onChange('date', null)
              }
            }}
            />

          <MyDateTimePicker
            dateTitle="Date d'envoi"
            timeTitle=''
            error={errors.date}
            date={item.date}
            disabled={!item.date}
            onChange={(date) => onChange('date', date)}
            />

          <div className="centered">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => sendPush(item)}
              disabled={!canSend(item)}
              >
              { saving ? 'Chargement...' : 'Envoyer ma notif' }
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <EditContainer
      id={props.match.params.id}
      error={error}

      onSave={onSave}
      onRemove={onRemove}
      renderTitle={() => 'Nouvelle notification'}
      renderContent={renderContent}
      />
  );
}

export default withRouter(NotifScreen)
